// extracted by mini-css-extract-plugin
export default {"wrapper":"BookingSuccess_wrapper__VZtOG","booking_info":"BookingSuccess_booking_info__DddYM"};